import React from "react";
import { Modal, ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import AddNewNote from "accountOwner/pages/TaskManagement/AddNewNote/AddNewNote";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { withTranslation } from "react-i18next";

function AddNewTaskModal({ t, isModalOpen, closeModalHandler, editTaskId }) {
  const history = useHistory();

  return (
    <Modal
      isOpen={isModalOpen}
      toggle={closeModalHandler}
      className="modal-lg modal-dialog-centered"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={closeModalHandler}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <h1 className="title">
          {editTaskId
            ? t("taskManagement.editNewTask")
            : t("taskManagement.addNewTask")}
        </h1>
        <AddNewNote
          isInsideModal={true}
          history={history}
          editTaskId={editTaskId}
          closeModalHandler={closeModalHandler}
        />
      </ModalBody>
    </Modal>
  );
}
export default withTranslation()(AddNewTaskModal);
